<template>
  <b-container>

    <b-col class="text-left">
      <b-button @click="$router.go(-1)" pill variant="purple" class="ml-1 mb-1">
        بازگشت به صفحه محصولات
      </b-button>
    </b-col>

    <b-form @submit.prevent="onSubmit">
      <h5>{{ title }}</h5>

      <name-and-link-manager
          :router-link="{ name: 'Product', params: { name: form.nameAndLink.link } }"
          :label="'نام محصول'"
          v-model="form.nameAndLink"
          :validation="$v.form.nameAndLink.name">
        <published-checkbox label="وضعیت انتشار" v-model="form.published"/>

      </name-and-link-manager>


      <b-row class="mt-5">

        <published-checkbox label="محصول دیجیتال است؟" v-model="form.is_digital"/>
      </b-row>

      <b-row class="mt-5 mb-2">عکس های محصول</b-row>
      <b-row>
        <!--   select multiple image and show their preview   -->
        <b-col sm="12" md="12">
          <multi-image-input @removeImage="removeImage" v-model="form.images" :previews="form.preview"/>
        </b-col>

        <b-col sm="12" md="12">
          <single-image v-model="form.mainImage" :mainPreview="form.mainPreview"
                        :validation="$v.form.mainImage"></single-image>

        </b-col>


      </b-row>

      <b-row class="mt-5">مشخصات محصول</b-row>
      <b-row class="mt-2">
        <brand
            :brands="brands" v-model="form.selectedBrand"
            :validation="$v.form.selectedBrand"
        />

        <check-box-manager :CheckBoxItems="categories" label="انتخاب دسته بندی"
                           :selectedCheckBoxes="form.selectedCategory" :validation="$v.form.selectedCategory"/>
      </b-row>
      <b-row class="mt-5">
        <b-col md="3" v-if="form.variation==false">
          <form-input :custom_class_on_input="`text-left`" v-model="form.price" label="قیمت"
                      :validation="$v.form.price"/>
        </b-col>
        <b-col md="3" v-if="form.variation==false">
          <form-input :custom_class_on_input="`text-left`" v-model="form.quantity" label="تعداد موجود در انبار"
                      :validation="$v.form.quantity"/>
          <span>نکته: در صورت خالی گذاشتن این بخش "تعداد موجودی" بینهایت در نظر گرفته میشود.</span>
        </b-col>
        <b-col md="3" v-if="!form.is_digital">
          <form-input :custom_class_on_input="`text-left`" v-model="form.shippingCost" label="هزینه ارسال"
                      :validation="$v.form.shippingCost"/>
          <span>در صورت تغییر ندادن این بخش هزینه ارسال از بخش تنظیمات، برای سفارش تنظیم میشود.</span>
        </b-col>
        <b-col md="3" v-if="form.variation==false">
          <form-input :custom_class_on_input="`text-left`" v-model="form.discount" label="تخفیف"
                      :validation="$v.form.discount"/>
        </b-col>
      </b-row>

      <b-row class="mt-5">

        <form-group :validations="$v.form.description" class="w-100">
          <div slot-scope="{ errors, invalid }">
            <label>توضیحات</label>
            <b-row>
              <b-col lg="6">
                <AddImageToEditor @image-handler="imageHandlerFunction" :title="form.titleAndSlug"/>
              </b-col>
              <b-col lg="6">
                <AddVideoToEditor @video-handler="videoHandlerFunction"/>
              </b-col>
            </b-row>
            <div class="form-group">
              <vue-editor :editor-toolbar="defaultToolbar" dir="ltr" v-model="form.description"/>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </b-row>

      <b-row>
        <b-col>
          <div class="custom-control custom-switch">
            <input type="checkbox" name="check-button" v-model="form.variation" class="custom-control-input"
                   :id="`variation`"/>
            <label class="custom-control-label" :for="`variation`">محصول متغییر دارد؟</label>
          </div>
          <b-button variant="danger" v-if="form.variation" pill v-b-modal.variation-product>اضافه کردن متغییر</b-button>
        </b-col>
      </b-row>

      <b-modal id="variation-product" hide-footer size="lg" dir="rtl">
        <VariationProductManager :Features="features" :itemsTable="selectedFeatureVariation"
                                 :selectFeature="featureVariation" :featureItemTable="form.items"/>
      </b-modal>

      <features-manager v-if="showFeatureManager" @create-feature-event="updateFeatureListAfterCreateNewFeature"
                        :Features="features"
                        :itemsTable="form.items"
                        :selectFeature="form.selectedFeature"/>

      <key-words-manager :keyWords="form.keyWords" :TableItems="form.table"/>
      <b-row class="my-5">
        <b-col md="8" class="m-auto">
          <b-button pill type="submit" variant="purple" class="w-100"
          >تایید
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>
<script>
import {mapGetters} from "vuex";
import router from '@/router';
import {required, numeric} from "vuelidate/lib/validators";
import {VueEditor} from "vue2-editor";
import {defaultToolbar} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/EditorToolbarSetting'
import category from "./category";
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import SingleImage from "../Content/FormItems/SingleImage.vue";
import RadioBox from "../Content/FormItems/RadioBox.vue";
import CheckBoxManager from "../Content/FormItems/CheckBoxManager.vue";
import FormInput from "../Content/FormItems/FormInput.vue";
import FormTextArea from "../Content/FormItems/FormTextArea.vue";
import FeaturesManager from "../Content/FormItems/FeaturesManager.vue";
import KeyWordsManager from "../Content/FormItems/KeyWordsManager.vue";
import NameAndLinkManager from "../Content/FormItems/NameAndLinkManager.vue";
import PublishedCheckbox from "../Content/FormItems/PublishedCheckbox.vue";
import VariationProductManager from "../Content/FormItems/VariationProductManager";
import AddImageToEditor from "../Content/FormItems/AddImageToEditor";
import AddVideoToEditor from "../Content/FormItems/AddVideoToEditor";
import Brand from './Brand'
import MultiImageInput from './MultiImageInput'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

function setupFeature(feature) {

  let result;

  if (feature.type === 'text') {

    result = {
      id: feature.feature_values.id,
      feature_id: feature.feature_values.feature_id,
      name: feature.public_name,
      feature_attributes: feature.feature_attributes[0].id,
      selected_feature_attribute_id: feature.feature_attributes[0].id,
      type: feature.type,
      update_info: {
        id: feature.feature_values.id,
      },
      value: feature.feature_values.feature_value,
      variation: feature.feature_values.variation,
      product_id: feature.feature_values.product_id,
      quantity: 0,
      offer: 0,
      price: 0,
    }

  }
  if (feature.type === 'list' && (feature.variation == 1 || feature.feature_values.variation == 1) && feature.feature_values.link_feature != null) {
    let feature_name = feature.public_name + ' - ' + feature.feature_values.link_feature.name;

    let f1_attributes = feature.feature_attributes
    let f2_attributes = feature.feature_values.link_feature.feature_attributes

    let f1_selected_attribute_id = feature.feature_values.feature_attribute_id
    let f2_selected_attribute_id = feature.feature_values.link_feature_value.feature_attribute_id

    const quantity = feature.feature_values.link_feature_value.quantity;
    const offer = feature.feature_values.link_feature_value.offer;
    const price = feature.feature_values.link_feature_value.price;

    let feature_attribute_name = '';

    f1_attributes.forEach(item => {
      if (f1_selected_attribute_id == item.id) {
        feature_attribute_name += item.value;
      }
    })

    f2_attributes.forEach(item => {
      if (f2_selected_attribute_id == item.id) {
        feature_attribute_name += ' - ' + item.value;
      }
    })

    result = {
      id: feature.feature_values.link_feature_value.id,


      update_info: {
        id: feature.feature_values.link_feature_value.id,
        product_id: feature.feature_values.link_feature_value.product_id,
        feature_id: feature.feature_values.link_feature_value.feature_id,
        feature_attribute_id: feature.feature_values.link_feature_value.feature_attribute_id,
        feature_value: feature.feature_values.link_feature_value.feature_value,
        variation: feature.feature_values.variation,
      },

      name: feature_name,
      feature_id: feature.id,
      feature_attributes: [{value: feature_attribute_name, text: feature_attribute_name}],
      selected_feature_attribute_id: f1_selected_attribute_id,
      type: feature.type,
      text: feature_attribute_name,
      value: feature_attribute_name,
      variation: feature.feature_values.variation,
      quantity: quantity,
      offer: offer,
      price: price,
    }
  }
  if (feature.type === 'list' && (feature.variation == 0 || feature.feature_values.variation == 0)) {
    let feature_name = feature.public_name


    result = {
      id: feature.id,
      name: feature_name,
      feature_id: feature.id,
      feature_attributes: feature.feature_attributes.map(item => {
        return {text: item.value, value: item.id}
      }),
      update_info: {
        id: feature.feature_values.id,
        product_id: feature.feature_values.product_id,
        feature_id: feature.feature_values.feature_id,
        feature_attribute_id: feature.feature_values.feature_attribute_id,
        feature_value: feature.feature_values.feature_value,
        variation: feature.feature_values.variation,
      },
      value: feature.feature_values.feature_attribute_id,
      type: feature.type,
      variation: feature.feature_values.variation,

    }
  }
  if (feature.type === 'list' && (feature.variation == 1 || feature.feature_values.variation == 1) && feature.feature_values.link_feature == null) {
    let feature_name = feature.public_name

    let f1_attributes = feature.feature_attributes

    let f1_selected_attribute_id = feature.feature_values.feature_attribute_id

    const quantity = feature.feature_values.quantity;
    const offer = feature.feature_values.offer;
    const price = feature.feature_values.price;

    let feature_attribute_name = '';

    f1_attributes.forEach(item => {
      if (f1_selected_attribute_id == item.id) {
        feature_attribute_name += item.value;
      }
    })

    result = {
      id: feature.feature_values.id,


      update_info: {
        id: feature.feature_values.id,
        product_id: feature.feature_values.product_id,
        feature_id: feature.feature_values.feature_id,
        feature_attribute_id: feature.feature_values.feature_attribute_id,
        feature_value: feature.feature_values.feature_value,
        variation: feature.feature_values.variation,
      },

      name: feature_name,
      feature_id: feature.id,
      feature_attributes: [{value: feature_attribute_name, text: feature_attribute_name}],
      selected_feature_attribute_id: f1_selected_attribute_id,
      type: feature.type,
      text: feature_attribute_name,
      value: feature_attribute_name,
      variation: feature.feature_values.variation,
      quantity: quantity,
      offer: offer,
      price: price,
    }
  }

  return {...result, tag: 'update'}


}

export default {
  name: "CreateProductLayout",
  components: {
    category,
    FormGroup,
    FormErrorsManager,
    SingleImage,
    RadioBox,
    CheckBoxManager,
    FormInput,
    FormTextArea,
    FeaturesManager,
    KeyWordsManager,
    NameAndLinkManager,
    PublishedCheckbox,
    VariationProductManager,
    VueEditor,
    AddImageToEditor,
    AddVideoToEditor,
    Brand,
    MultiImageInput,
  },
  props: ["title", "submitFunction"],
  data() {
    return {
      showFeatureManager: true,
      featureVariation: [],
      selectedFeatureVariation: [],
      form: {
        images: [],
        mainImage: [],
        mainPreview: "",
        preview: [],
        selectedBrand: "",
        selectedCategory: [],
        selectedFeature: [],
        price: null,
        quantity: null,
        shippingCost: null,
        discount: null,
        published: false,
        description: "",
        items: [],
        id: "",
        keyWords: [],
        table: [],
        nameAndLink: {name: "", link: ""},
        is_digital: false,
        variation: false
      },
      defaultToolbar
    };
  },
  validations: {
    form: {
      nameAndLink: {name: {required}},
      selectedBrand: {},
      selectedCategory: {},
      items: {},
      price: {numeric},
      quantity: {numeric},
      shippingCost: {numeric},
      discount: {numeric},
      description: {},
      variation: {},
      mainImage: {
        required: (value) => {
          return router.currentRoute.params.slug != undefined || value.length !== 0
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      categories: "Category/getCategories",
      brands: "Brand/getBrands",
      features: "Feature/getFilteredFeatures",
    }),
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        let form = {};

        form = {
          name: this.form.nameAndLink.name,
          link: this.form.nameAndLink.link,
          ...this.form,
        };
        this.submitFunction(form)
            .then((res) => {
              const product = res.data.data;
              if (this.$router.currentRoute.params.slug !== product.raw_link) {
                router.push({
                  name: "EditProduct",
                  params: {slug: product.raw_link},
                });
              }
              if (this.$route.params.slug !== undefined) {
                this.setComponentForm('image')
                this.$store.commit("Product/setProduct", product);
              }

            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    async setComponentForm(mode = 'all') {
      this.form.nameAndLink.link = this.$route.params.slug;
      this.$store
          .dispatch("Product/getDashboardProduct", this.form.nameAndLink.link)
          .then(async (res) => {

            if (mode === 'all') {

              this.form.nameAndLink.name = await res.name;
              this.form.id = await res.id;
              this.form.nameAndLink.link = await res.raw_link;
              this.form.published = await res.status ? true : false;
              this.form.mainPreview = await res.thumbnail;
              this.form.price = await res.price;
              this.form.quantity = await res.quantity;
              this.form.shippingCost = await res.delivery_amount;
              this.form.discount = await res.offer;
              this.form.is_digital = await res.is_digital == 1 ? true : false;
              this.form.variation = await res.variation == 1 ? true : false;

              if (res.description == null) {
                this.form.description = "";
              } else {
                this.form.description = await res.description;
              }

              if (res.brand == null) {
                this.form.selectedBrand = '';
              } else {
                this.form.selectedBrand = await res.brand;

              }

              await res.category.forEach((category) => {
                try {
                  document
                      .getElementById(`category_${category.id.toString()}`)
                      .click();
                } catch (e) {
                  console.log(`category not found: ${e}`)
                }

              });


              await res.features.forEach((feature) => {

                this.form.items.push(setupFeature(feature));

              });


              await res.images.forEach((image) => {
                this.form.preview.push(image.file);
              });


              await res.keywords.forEach((keyword) => {
                this.form.keyWords.push(keyword.keyword);
                this.form.table.push({name: keyword.keyword});
              });
            }

            if (mode === 'features') {

              const features = await res.features

              await this.form.items.push(setupFeature(features[features.length - 1]))


            }

            if (mode === 'image') {
              this.form.images = []
              this.form.preview = []
              await res.images.forEach((image) => {
                this.form.preview.push(image.file);
              });
            }

          })
          .catch((err) => {
            this.$router.push({name: "ProductsDashboard"});
            console.log(err);
          });
    },
    async updateFeatureListAfterCreateNewFeature(createdFeature) {
      await this.form.items.splice(this.form.items.indexOf(createdFeature), 1);

      this.showFeatureManager = false;

      await this.$nextTick(async () => {
        await this.setComponentForm('features', createdFeature)
        this.showFeatureManager = true
      })
    },
    imageHandlerFunction(image) {
      this.form.description += image;
    },
    videoHandlerFunction(video) {
      this.form.description += video;
    },
    removeImage() {
      this.setComponentForm('image')
    }
  },
  async mounted() {
    await this.$store.dispatch("Category/getCategories");
    await this.$store.dispatch("Brand/getBrands");
    await this.$store.dispatch("Feature/getFeatures");
    const routerLink = this.$route.params.slug;
    if (routerLink !== undefined) {
      await this.setComponentForm()

    }
  },
};
</script>
<style scoped>
.direction {
  direction: rtl;
}

.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}
</style>
